import { useState, useEffect } from 'react';
import api from '@/utils/api';

let cachedCurrency = null;

export function useGeoCurrency() {
  const [currency, setCurrency] = useState(cachedCurrency || 'USD');
  const [loading, setLoading] = useState(!cachedCurrency);

  useEffect(() => {
    if (cachedCurrency) return;
    api.get('/geo/detect')
      .then(r => {
        const c = r.data?.currency || 'USD';
        cachedCurrency = c;
        setCurrency(c);
      })
      .catch(() => {
        cachedCurrency = 'USD';
      })
      .finally(() => setLoading(false));
  }, []);

  return { currency, loading };
}
